import './ProgressBar.css';

export interface ProgressBarProps {
  /** Omit (or pass `null`) for the indeterminate state — AC-WAN-1 explicitly forbids a bare
   * spinner once real bytes/sec are known, but before that first measurement indeterminate is
   * still honest. */
  value?: number | null;
  label: string;
  /** Small text under the bar, e.g. "1.4 MB/s — 3s left" (AC-WAN-1/AC-WAN-9). */
  detail?: string;
}

/** DESIGN.md §9.1 `ProgressBar` (determinate + indeterminate). Used by `BufferingCard` and the
 * ingest ecosystem; this file is the one implementation both read from. */
export function ProgressBar({ value, label, detail }: ProgressBarProps) {
  const determinate = typeof value === 'number' && Number.isFinite(value);
  const clamped = determinate ? Math.min(100, Math.max(0, value as number)) : 0;
  return (
    <div className="progress-bar">
      <div
        className={['progress-bar__track', determinate ? '' : 'progress-bar__track--indeterminate'].filter(Boolean).join(' ')}
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={determinate ? Math.round(clamped) : undefined}
      >
        {/* MVP-367: `scaleX`, not `width` — see `ProgressBar.css`. Indeterminate passes no inline
            style at all, leaving the CSS animation to own the transform. */}
        <div className="progress-bar__fill" style={determinate ? { transform: `scaleX(${clamped / 100})` } : undefined} />
      </div>
      {detail && <span className="progress-bar__detail text-meta tabular-nums">{detail}</span>}
    </div>
  );
}
